import { OktaConfig } from '@okta/okta-angular';

export * from './lib/framwork-okta-login.module';
export * from './lib/okta-authGaurd';
export * from './lib/okta-login.component';
export * from './lib/logout.component';

export interface OktaConfig2 extends OktaConfig {
  baseUrl: string;
}
